export default {
    SET_LIST_MAIL_ERRORS(state, payload) {
      let result = [];
      result = payload
      state.listMailError = result
    },
    SET_INFO_DB(state, payload){
      state.infoDB = payload
    },
  }